import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const absolute = defineConnector({
  identifier: "absolute",
  name: "Absolute",
  tagLine: "Endpoint security and management",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `https://${apiAddress.replace(/\./g, "\\.")}/.*`
      : "https://api(?:\\.[^.]+)?\\.absolute(?:gov)?\\.com/.*",
  auth: customAuth("absolute"),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the **Secure Endpoint Console**, open **API Token Management**, click **Create API Token**, choose **Generate Token** (symmetric), and save the **Token ID** and **Secret key**. The secret key is shown once — capture it before closing.",
        },
      ],
    },
    {
      title: "Select your API address",
      items: [
        {
          kind: "select",
          label: "API address",
          required: true,
          defaultValue: "api.absolute.com",
          target: { kind: "configuration", field: "apiAddress" },
          helperText:
            "Match your Secure Endpoint Console login URL (e.g., cc.us.absolute.com → api.us.absolute.com).",
          options: [
            { value: "api.absolute.com", label: "api.absolute.com" },
            { value: "api.us.absolute.com", label: "api.us.absolute.com" },
            { value: "api.eu2.absolute.com", label: "api.eu2.absolute.com" },
            { value: "api.in1.absolute.com", label: "api.in1.absolute.com" },
            {
              value: "api.fr1.absolutegov.com",
              label: "api.fr1.absolutegov.com",
            },
          ],
        },
      ],
    },
    {
      title: "Enter your token",
      items: [
        {
          kind: "input",
          label: "Token ID",
          required: true,
          target: { kind: "secrets", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) =>
      `https://${apiAddress}/v3/reporting/devices?%24top=1`,
  },
});
